import axios from "axios";
import {collectResponse} from "./ResponseStack";

export default class {

    constructor(options = null) {
        this.options = options || {};
        this.client = null;
        this.token = null;

        if (null !== options) {
            this.initialize(options);
        }
    }

    setToken(token) {
        this.token = token;
    }

    initialize(options) {
        this.options = options;
        this.client = axios.create(options);
    }

    isCancel(error) {
        return axios.isCancel(error)
    }

    createCancelToken() {
        return axios.CancelToken.source();
    }

    query(resource, params, config = {}) {
        return this.request('get', resource, params, config);
    }

    get(resource, slug = '', params = {}, config = {}) {
        return this.request('get', `${resource}/${slug}`, params, config);
    }

    post(resource, params, config = {}) {
        return this.request('post', resource, params, config);
    }

    patch(resource, slug, params, config = {}) {
        return this.request('patch',`${resource}/${slug}`, params, config);
    }

    put(resource, params, config = {}) {
        return this.request('put', resource, params, config);
    }

    delete(resource) {
        return this.request('delete', resource);
    }

    request(type, resource, params = {}, config = {}) {
        if (null === this.client) {
            throw new Error('Api client was not initialized.');
        }

        if (null !== this.token) {
            config.headers = config.headers || {};
            config.headers.Authorization = 'Bearer ' + this.token;
        }

        return new Promise((resolve, reject) => {
            const url = resource.replace(/\/+$/, '');
            const request = ['get', 'delete'].includes(type)
                ? this.client[type](url, {...config, params: params })
                : this.client[type](url, params, config);

            request.then((response) => {
                collectResponse(response);
                resolve({
                    data: response.data.data || {},
                    meta: response.data.meta || {},
                    status: response.status,
                    response: response
                });
            }).catch((error) => {
                if (this.isCancel(error)) {
                    return;
                }

                const response = error.response || {};
                const data = response.data || {};
                const errors = data.errors || [data.detail || error.message || 'Unknown error'];
                collectResponse(error.response ? error.response : JSON.parse(JSON.stringify(error)));
                reject({
                    status: response.status || 500,
                    response,
                    meta: data.meta || {},
                    errors
                });
            });
        });
    }
}
